import { BrowserRouter } from 'react-router-dom';
import { ToastBar, Toaster, toast } from 'react-hot-toast';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import AppRouter from './navigation/AppRouter';
import { persistor, store } from './redux/store';
import { loader } from './redux/reducers/loadingSlice';
import Loader from './component/Loader';
import BackRedirectWatcher from './component/BackRedirectWatcher';
import { Icons } from './assets';

function App() {
  const loading = useSelector(loader);

  return (
    <>
      <Loader show={loading} />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Toaster
              position='top-right'
              gutter={8}
              reverseOrder
              containerClassName='custom-toast'
              containerStyle={{ top: '100px' }}
            >
              {(t) => (
                <ToastBar toast={t} style={{ padding: 0, maxWidth: '420px' }}>
                  {({ icon, message }) => (
                    <div
                      className={`
                        flex items-start justify-start gap-2.5
                        pl-3 pr-9 py-2.5 rounded min-w-[300px] max-w-[400px] w-auto text-sm shadow-lg relative 
                        ${t.type === 'success' ? 'border border-[#09bc54] bg-[#09bc5430]' : ''} 
                        ${t.type === 'error' ? 'border border-[#FC0000] bg-[#FC000030]' : ''}
                        ${t.type !== 'success' && t.type !== 'error' ? 'border border-gray-200 bg-white' : ''}
                      `}
                    >
                      {icon && <div className='flex-shrink-0 mt-0.5'>{icon}</div>}

                      <div className='flex-1 min-w-0'>
                        <div className='font-primarySemiBold text-[15px] break-words leading-snug'>
                          {message}
                        </div>
                        {t?.messageDesc?.trim() && (
                          <div className='font-primaryLight mt-1 text-[14px] break-words'>
                            {t?.messageDesc}
                          </div>
                        )}
                      </div>

                      <button
                        onClick={() => toast.dismiss(t.id)}
                        className='absolute top-2.5 right-2.5 p-1 rounded hover:opacity-75 flex items-center justify-center'
                        aria-label='Close'
                      >
                        <img src={Icons.cross} alt='close' className='w-3 h-3' />
                      </button>
                    </div>
                  )}
                </ToastBar>
              )}
            </Toaster>

            <BackRedirectWatcher />
            <AppRouter />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
